import { render } from "./topbar.vue?vue&type=template&id=489251d0"
import script from "./topbar.vue?vue&type=script&lang=js"
export * from "./topbar.vue?vue&type=script&lang=js"

import "./topbar.vue?vue&type=style&index=0&id=489251d0&lang=scss"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__